// ThreeScene.js
import React, { useState, useCallback, useMemo } from "react";
import ThreeJSContainer from "./ThreeJSContainer";
import ThreeImageView from "../ThreeImageView/ThreeImageView";

const ThreeScene = ({ nonImageUrls, immagini, disabled, handleDeleteFile }) => {
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleDeleteImage = useCallback(
    (index) => {
      const urlToDelete = nonImageUrls[index];
      if (!urlToDelete) return;

      const match = immagini.find(
        (item) => item.immagineId === urlToDelete.immagineId
      );
      if (!match) return;

      handleDeleteFile(match.id, match.immagineId);
    },
    [nonImageUrls, immagini, handleDeleteFile]
  );

  const handleEnlarge = useCallback(
    (index) => {
      const urlToEnlarge = nonImageUrls[index];
      setEnlargedImage(urlToEnlarge.url);
    },
    [nonImageUrls]
  );

  const objUrls = useMemo(() => {
    return nonImageUrls.map((obj) => obj.url);
  }, [nonImageUrls]);

  return (
    <div className="three-scene-container">
      {objUrls.map((objUrl, index) => (
        <ThreeJSContainer
          key={`${objUrl}-${index}`}
          disabled={disabled}
          glbUrl={objUrl}
          handleDeleteImage={handleDeleteImage}
          handleEnlarge={handleEnlarge}
          index={index}
        />
      ))}
      {enlargedImage && (
        <ThreeImageView
          show={enlargedImage}
          glbUrl={enlargedImage}
          handleClose={() => setEnlargedImage(null)}
        />
      )}
    </div>
  );
};

export default ThreeScene;
